import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import {useDispatch, useSelector} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import axios from 'axios';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeftOutlinedIcon from '@material-ui/icons/KeyboardArrowLeftOutlined';
import lng from '../../../misc/lng';
import envConst from '../../../misc/envConst';
import CartItemGrid from './CartItemGrid';
import DiscountDisplayGrid from './DiscountDisplayGrid';
import {setLoadingWrapper} from '../../../actions/dineIn';
import { useFontSize } from '../../../contexts/FontSizeContext';
import { filterVoidOrders } from '../../../utils/orderFilterFunc';
import moment from 'moment';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
  });

const {chiLng} = lng;

const useStyles = makeStyles(() => ({
    wrapper: {
        backgroundColor: '#f1efef',
        marginBottom: '80px',
    },
    titleWrapper: {

    },
    title: {
        paddingLeft: '10px',
        paddingTop: '30px',
        paddingBottom: '10px'
    },
    subTitle: {
        opacity: '0.7',
    },
    editTitle: {
        opacity: '0',
    },
    titleWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: '20px',
        alignItems: 'center',
        backgroundColor: 'white',
    },
    footer: {
        position: 'fixed',
        left: '0',
        bottom: '0',
        width: '100%',
        height: '70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        boxShadow: '0px 0 5px rgba(0, 0, 0, 0.8)',
        padding: '10px',
    },
    addOrderBtn: {
        width: '90%',
        height: '40px',
        color: 'white',
        backgroundColor: '#666666',
        borderRadius: '10px',
        fontSize: '30px',
        lineHeight: '40px',
    },
    totalPriceWrapper: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
    },
    priceTotalTitle: {
        marginLeft: '10px',
    },
    priceTotal: {
        marginRight: '10px',
    },
    productData: {
        margin: '10px 0',
        backgroundColor: 'white',
        paddingLeft: '10px',
        paddingRight: '10px',
    },
    selectedProductData: {
        margin: '10px 0',
        paddingLeft: '10px',
        paddingRight: '10px',
        backgroundColor: 'rgb(192 199 194)',
    },
    productSummary: {
        margin: '10px 0',
        backgroundColor: 'white',
        paddingLeft: '10px',
        paddingRight: '10px',
    },
    confirmedOrdersHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 8px 0',
        borderRadius: '8px',
        marginBottom: '8px',
        cursor: 'pointer',
    },
    confirmedOrdersTitle: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'bold',
        color: '#333',
    },
    confirmedOrdersCount: {
        marginLeft: '8px',
        backgroundColor: '#4CAF50',
        color: 'white',
        borderRadius: '12px',
        padding: '2px 8px',
        fontSize: '12px',
        fontWeight: 'bold',
    },
    confirmedOrdersContent: {
        borderRadius: '8px',
        padding: '0',
        marginBottom: '0',
    },
    summaryCard: {
        backgroundColor: 'white',
        borderRadius: '12px',
        margin: '10px',
        padding: '16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e0e0e0',
    },
    summaryDivider: {
        margin: '12px 0',
        borderColor: '#e0e0e0',
    },
  }));


export default (props) => {
    const classes = useStyles();
    const {
        productData, productSummary
    } = useSelector((store) => store.productsReducer);
    const {
        tableInCharge: {
            id,
            orders,
        },
    } = useSelector((store) => store.dineInReducer);
    const {priceAfterDiscount, tagSetDiscountList} = productSummary;
    const validOrders = filterVoidOrders(orders);
    const [confirmedOrdersExpanded, setConfirmedOrdersExpanded] = useState(false);
    const dispatch = useDispatch();
    const { getFontSize } = useFontSize();

    // Dynamic font sizes
    const titleFontSize = getFontSize('sectionHeader');
    const mealTitleFontSize = getFontSize('mealTitle');
    const subtitleFontSize = getFontSize('subtitle');
    const priceFontSize = getFontSize('priceMain');
    const buttonFontSize = getFontSize('buttonText');



    const handleClose = () =>{
        props.handleClose();
    }
    const handleAddOrder = () => {
        dispatch(setLoadingWrapper('loading', ''));
        const orderTime = new Date();

        // Helper function to clean spec data for server
        const cleanSpecData = (spec) => {
            if (!spec || !Array.isArray(spec)) return spec;

            return spec.map(specGroup => ({
                mealSpecId: specGroup.mealSpecId,
                specTitle: specGroup.specTitle,
                minQty: specGroup.minQty,
                maxQty: specGroup.maxQty,
                selectionRule: specGroup.selectionRule ? {
                    ruleType: specGroup.selectionRule.ruleType || 'any',
                    min: specGroup.selectionRule.min || 0,
                    max: specGroup.selectionRule.max,
                    exact: specGroup.selectionRule.exact
                } : {
                    ruleType: 'any',
                    min: 0
                },
                specOptions: specGroup.specOptions ? specGroup.specOptions.map(opt => ({
                    specId: opt.specId,
                    specName: opt.specName,
                    specStock: opt.specStock || 0,
                    specPrice: opt.specPrice || 0,
                    printerName: opt.printerName || '',
                    printerId: opt.printerId,
                    selected: opt.selected || false
                })) : [],
                mealId: specGroup.mealId,
                qtyLimit: specGroup.qtyLimit || 1
            }));
        };

        const orderData = {
            orderTime,
            orderDetails: productData.map(
                (meal) => {
                    // Clean productSpec data - always include productSpec array (empty for non-spec items)
                    const cleanedProductSpec = meal.hasMenuSpec === 'true' && meal.productSpec ?
                        meal.productSpec.map(ps => ({
                            priceForOne: ps.priceForOne,
                            qty: ps.qty,
                            spec: cleanSpecData(ps.spec)
                        })) : [];

                    return {
                        mealCategoryId: meal.mealCategoryId,
                        mealSubCategoryId: meal.mealSubCategoryId,
                        mealId: meal.mealId,
                        name: meal.name,
                        additionalOptionCategory: meal.additionalOptionCategory,
                        additionalOptionCategoryInUsed: meal.additionalOptionCategoryInUsed,
                        qty: meal.qty,
                        price: meal.price,
                        weekday: meal.weekday,
                        img: meal.img,
                        tag: meal.tag,
                        hasMenuSpec: meal.hasMenuSpec,
                        productSpec: cleanedProductSpec,  // Use cleaned productSpec
                        printerName: meal.printerName,
                        simpleOptions: meal.simpleOptions,
                    };
                }
            ),
        };
        console.log(orderData);
        const addOrderUrl =  `${envConst.API_ADD_ORDER}`;
        axios.post(addOrderUrl,
            {
                id,
                order: orderData,
                productSummary,
                replaceOriginal: false,
            }
        ).then(
            (res) => {
                dispatch(setLoadingWrapper('completed', ''));
                console.log('res')
                console.log(res)
                if (res && res.data && res.data.result && res.data.result.success) {
                    dispatch(setLoadingWrapper('addOrderSuccess', ''));

                } else {
                    dispatch(setLoadingWrapper('fail', chiLng.orderFailMsg));

                }
            },
            () => {
                dispatch(setLoadingWrapper('fail', chiLng.orderFailMsg));
            }
        );
    }



    const getReadyToOrderBox = () => {
        if (productData.length > 0) {
            return (
                <React.Fragment>
                    {/* Title Card */}
                    <div className={classes.summaryCard}>
                        <Typography variant='inherit' align='center' style={{ fontSize: titleFontSize }}>
                            {chiLng.readyToOrderTitle}
                        </Typography>
                    </div>

                    {/* Items Card */}
                    <div className={classes.summaryCard}>
                        {
                            productData.map((orderDetail, idx) => {
                                return (
                                    <div
                                        key={`orderCartItemGrid_${idx}`}
                                        style={{
                                            margin: '8px 0',
                                            padding: '10px',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <CartItemGrid
                                            orderDetail={orderDetail}
                                            idx={idx}
                                        />
                                    </div>
                                );
                            })
                        }
                    </div>
                </React.Fragment>
            );
        }
        return null;
    }

    const getConfirmedOrdersBox = () => {
        if (validOrders.length > 0) {
            const totalConfirmedItems = validOrders.reduce((total, order) =>
                total + order.orderDetails.reduce((orderTotal, detail) => {
                    if (detail.hasMenuSpec === 'true' && detail.productSpec) {
                        return orderTotal + detail.productSpec.length;
                    }
                    return orderTotal + 1;
                }, 0), 0
            );

            return (
                <React.Fragment>
                    {/* Confirmed Orders Header Card */}
                    <div className={classes.summaryCard}>
                        <div
                            className={classes.confirmedOrdersHeader}
                            onClick={() => setConfirmedOrdersExpanded(!confirmedOrdersExpanded)}
                        >
                            <div className={classes.confirmedOrdersTitle}>
                                <CheckCircleIcon style={{ fontSize: 20, marginRight: 8, color: '#4CAF50' }} />
                                {chiLng.confirmedOrderTitle}
                                <span className={classes.confirmedOrdersCount}>
                                    {totalConfirmedItems}
                                </span>
                            </div>
                            {confirmedOrdersExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </div>
                    </div>

                    {/* Confirmed Orders Content Card */}
                    <Collapse in={confirmedOrdersExpanded}>
                        <div className={classes.summaryCard}>
                            <div className={classes.confirmedOrdersContent}>
                            {validOrders.map((order, orderIndex) => (
                                <div key={orderIndex} style={{ marginBottom: '16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', color: '#757575', fontSize: '14px' }}>
                                        <AccessTimeIcon style={{ fontSize: 16, marginRight: 4 }} />
                                        {chiLng.orderTime}: {moment(order.orderTime).format('HH:mm')}
                                        <CheckCircleIcon style={{ fontSize: 16, marginLeft: 16, marginRight: 4, color: '#4CAF50' }} />
                                        已確認
                                    </div>
                                    {order.orderDetails.map((orderDetail, itemIndex) => {
                                        // Handle meals with specifications (hasMenuSpec === 'true')
                                        if (orderDetail.hasMenuSpec === 'true' && orderDetail.productSpec) {
                                            return orderDetail.productSpec.map((productSpecItem, specIndex) => (
                                                <div key={`${orderIndex}-${itemIndex}-${specIndex}`} style={{ marginBottom: '8px', padding: '8px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                                        <Typography variant="inherit" style={{ fontWeight: 'bold', fontSize: mealTitleFontSize }}>
                                                            {productSpecItem.qty} X {orderDetail.mealName || orderDetail.name}
                                                        </Typography>
                                                        <Typography variant="inherit" style={{ fontWeight: 'bold', fontSize: priceFontSize }}>
                                                            ${(productSpecItem.priceForOne * productSpecItem.qty).toFixed(2)}
                                                        </Typography>
                                                    </div>
                                                    {productSpecItem.spec && productSpecItem.spec.map((specItem, idx) => {
                                                        const specNameList = specItem.specOptions.map((opt) => {
                                                            if (opt.specPrice > 0) {
                                                                return `${opt.specName} $${opt.specPrice}`;
                                                            }
                                                            return opt.specName;
                                                        });
                                                        return (
                                                            <Typography key={idx} variant="inherit" style={{ color: '#757575', fontSize: subtitleFontSize }}>
                                                                - {specNameList.join(', ')}
                                                            </Typography>
                                                        );
                                                    })}
                                                    {orderDetail.simpleOptions && orderDetail.simpleOptions.length > 0 && (
                                                        <Typography variant="inherit" style={{ color: '#9E9E9E', fontSize: subtitleFontSize }}>
                                                            - {orderDetail.simpleOptions.join(', ')}
                                                        </Typography>
                                                    )}
                                                </div>
                                            ));
                                        } else {
                                            // Handle normal meals (hasMenuSpec !== 'true')
                                            return (
                                                <div key={`${orderIndex}-${itemIndex}`} style={{ marginBottom: '8px', padding: '8px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                                        <Typography variant="inherit" style={{ fontWeight: 'bold', fontSize: mealTitleFontSize }}>
                                                            {orderDetail.qty} X {orderDetail.mealName || orderDetail.name}
                                                        </Typography>
                                                        <Typography variant="inherit" style={{ fontWeight: 'bold', fontSize: priceFontSize }}>
                                                            ${(orderDetail.price * orderDetail.qty).toFixed(2)}
                                                        </Typography>
                                                    </div>
                                                    {orderDetail.simpleOptions && orderDetail.simpleOptions.length > 0 && (
                                                        <Typography variant="inherit" style={{ color: '#9E9E9E', fontSize: subtitleFontSize }}>
                                                            - {orderDetail.simpleOptions.join(', ')}
                                                        </Typography>
                                                    )}
                                                </div>
                                            );
                                        }
                                    }).flat()}
                                </div>
                            ))}
                            </div>
                        </div>
                    </Collapse>
                </React.Fragment>
            );
        }
        return null;
    }

    const getSummaryCard = () => {
        return (
            <div className={classes.summaryCard}>
                {/* Discount Section */}
                {tagSetDiscountList.length > 0 && (
                    <>
                        <DiscountDisplayGrid productSummary={productSummary} />
                        <Divider className={classes.summaryDivider} />
                    </>
                )}

                {/* Total Price Section */}
                <div className={classes.totalPriceWrapper}>
                    <Typography align='left' className={classes.priceTotalTitle} variant='inherit' style={{ fontSize: titleFontSize }}>
                        {`${chiLng.shoppingCartPriceTotal}`}
                    </Typography>
                    <Typography align='right' className={classes.priceTotal} variant='inherit' style={{ fontSize: priceFontSize }}>
                        {`$${priceAfterDiscount}`}
                    </Typography>
                </div>
            </div>
        );
    }

    return(
        <Dialog
            open={props.open}
            TransitionComponent={Transition}
            onClose={handleClose}
            fullScreen
        >
            <div className={classes.wrapper}>
                <div className={classes.titleWrapper}>
                    <IconButton aria-label="back" onClick={handleClose}>
                        <KeyboardArrowLeftOutlinedIcon fontSize="large"/>
                    </IconButton>
                    <Typography className={classes.subTitle} variant='inherit' style={{ fontSize: titleFontSize }}>
                        {chiLng.shoppingCart}
                    </Typography>
                    <Typography className={classes.editTitle} variant='inherit' style={{ fontSize: titleFontSize }}>
                        {chiLng.edit}
                    </Typography>
                </div>

                {getConfirmedOrdersBox()}
                {getReadyToOrderBox()}

                {getSummaryCard()}



                <div className={classes.footer}>
                    <Button
                        variant="contained"
                        size="large"
                        color="primary"
                        classes={{containedPrimary: classes.addOrderBtn}}
                        disabled={productData.length <= 0}
                        onClick={handleAddOrder}
                        style={{ fontSize: buttonFontSize }}
                    >
                        {`${chiLng.addOrder}`}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};